
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Tämän on tuonut
                    <a href="${0}">Folksonomy Engine -projekti</a>. Älä
                    epäröi osallistua tai antaa palautetta.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Tämän työkalun avulla voit korjata ainesosaluetteloa. Voit lisätä, poistaa tai muokata
                ainesosaluetteloa.
                <br>
                Tämä merkki <span class="highlight">␣</span> edustaa välilyöntiä.
                <br>
                Tämä merkki <span class="highlight">↩︎</span> edustaa rivinvaihtoa. `,
'hb28f1f2ec1744ee9': html`Käyttäjät luovat ja arkistoivat nämä ominaisuudet kaikenlaiseen käyttöön. Voit
                    lisätä omia ominaisuuksiasi. Luomiesi ominaisuuksien ja arvojen
                    <strong>on oltava tosiallisia</strong>. Voit perehtyä
                    <a href="${0}">yhteisön jo käyttämien ominaisuuksien luetteloon</a>
                    tai tutustua
                    <a href="${1}">ominaisuuksien dokumentaatioon ja sen hakukoneeseen</a>.`,
's000a5b76bd3a01c2': `Ominaisuuksia ladataan...`,
's000d98595e959c1e': `Saatavilla Google Playsta`,
's013bdc8cf0d3583d': `Auta meitä ainesosien hankinnassa`,
's01d2865e3e1d5501': `Kiitos avustasi!`,
's02ce7a2e7c1b020b': `Vahvista sato`,
's03e9c8114521b998': `Muokkaan ainesosat`,
's05ec315d9308091a': `Viivakoodin kulmat -kuvake`,
's061eb5af92512c85': `Tallennettu! Voitko auttaa toisen kanssa?`,
's06847c221c4c0bc1': `Haluaisin luoda ominaisuuden, jolla voin kuvailla käyttötapaustasi...`,
's06f6c6f99db6b552': `Alkuperäinen`,
's081e2ad82db71e1d': `Ryhmitellyt arvot`,
's09205907b5b56cda': `Ei`,
's0b4235aae602a950': `erillinen dokumentaatio`,
's0bb2d48532acc455': `Lataa CSV-tiedosto`,
's0d5b7fee0311db68': `Ominaisuus`,
's0fb218abc2e157ed': `Mitätöi kuva`,
's100c4928cc74642a': `tukemaan kansanterveystutkimuksen edistämistä.`,
's10db5498186c083b': `Peruuta rajaus`,
's11a18a69b30b65ed': `Auta meitä korjaamaan ainesosaluettelon virheet`,
's1205d5f6fccf8e69': `Kiinteistön arvo`,
's15d64a0a6715285a': `Uusi avain`,
's166bd56d19670a72': `Zoomaus`,
's19059bf0c4f7c162': `Valinta-alue`,
's1a52515ec8ddade8': `Tuotteen viivakoodi`,
's1c5031113de500ce': `pitäen tietokantamme avoimena &amp; kaikkien saatavilla,`,
's1dc4daf989c71284': `Auta meitä korjaamaan ravintotietoja`,
's1e00019dc454872d': `Anna ominaisuuden nimi käyttämällä property-name-attribuuttia.`,
's1e49126af0935a5b': `Luettelo tätä ominaisuutta käyttävistä tuotteista`,
's21e73088de6f26f3': `Saatavilla App Storesta`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Kiitos avustasi! Voitko auttaa toisen kysymyksen kanssa?`,
's2ceb11be2290bb1b': `Peruuta`,
's2db7b654c0a9bde0': `Dokumentoi kiinteistö`,
's300b3a6ee4e1252d': str`Huono osuma ${0}%`,
's33f786bb6b4f0cf4': `Rajaa tulos`,
's33f85f24c0f5f008': `Tallenna`,
's34be4af4e8fec4ae': `Kysy ensin yhteisöltä`,
's36d86adc823cbfa6': `Ennen uuden kiinteistön luomista, keskustele siitä yhteisön kanssa:`,
's3781d25aa51a736c': `Folksonomy-moottorin dokumentaatio`,
's383ae4449428b61e': `Palauta rajaus`,
's39bcf88721a1e8ee': `Palauta valinta`,
's39e14e14300694c7': `Dokumentaatio ja ohjeet`,
's3b430cfa5c1fe7f4': str`Dokumentaatio ${0}:lle`,
's3f4e4b52f230a892': `Kuvapohja`,
's417b90913e05bc17': `Esikatselu`,
's41f7dca46d3f1b4a': `Arvo`,
's422bba9636ce2489': `Keskitä kuva`,
's42dd66b2441566fd': `Keskikuvake`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Lisää ravintoaine`,
's453ab0dbb9b5c777': `Muuta kokoa oikealle`,
's475b08749d0706ed': `Auta meitä kertomaan miljoonille kuluttajille eri puolilla maailmaa siitä, mitä he syövät`,
's49730f3d5751a433': `Ladataan...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Tuotteiden määrä`,
's4df2f533c0c1e7d0': `Kuvan säätimet`,
's4e94adf723979402': `Open Food Facts tarvitsee apuasi tämän tuotteen kanssa.`,
's4f4886341969d552': `Siirrä valinta`,
's4f751fb9b3ed766c': `Uuden ominaisuuden luominen`,
's547c12ae169d00bc': `Saatavilla F-Droidissa`,
's5560fb119e40923d': `Anna kiinteistön nimi...`,
's55d7249883a98ca1': `Tietoja tästä majoituspaikasta Open Food Facts -wikissä`,
's565867d84c04aea2': `Suodattimen ominaisuudet...`,
's5666afe5cd0166de': `Korjaa virheet tai muokkaa tekstiä ennen vahvistamista`,
's57472465a23b41db': `Arvot`,
's58e1eeea7a60ae51': `Tuotteita ladataan...`,
's59df20feee978e5b': `Virhe: Virheellinen arvo.`,
's5c92c0051d44b6de': `Auta meitä korjaamaan ravintosisältötiedot.`,
's5dd6f12783fca34f': `Muokkaa ainesosaluetteloa`,
's5e8250fb85d64c23': `Sulje`,
's5ed03bb1f3a15949': `Kuva`,
's6306a31415aea913': `TUEN`,
's6498dfe4855bb3a7': `yksikkö`,
's64ef2a6c2dd1d3d1': `Muokkaa`,
's66413c24dcf680e2': `Ohita`,
's67ae6594857a4d57': `Kiitos panostuksestasi!`,
's6cee7cad81dfedd1': `Rajattu kuva`,
's6d7b6cdedaadfb6e': `Jokainen lahjoitus on tärkeä! Arvostamme tukeasi elintarvikkeiden avoimuuden lisäämisessä maailmassa.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Hyvä osuma ${0}%`,
's71a5c9f4b68ef4d4': `Määrä`,
's74cb3d66f6a668e1': `Dokumentaatio`,
's787dd11bed0dc88a': `Muuta kokoa vasemmalle`,
's7ce4fd9430e80cea': `arvo`,
's801a05fa8e881f37': `Lisätietoja kiinteistöjen luomisesta ja ohjeista:`,
's8038273de2cf8b73': `Valitse rajattava alue.`,
's839cc2908a5387f2': `Suodata viivakoodit...`,
's86197dcf3e96af64': `Selaa ja hae olemassa olevia kiinteistöjä`,
's8a63be30a129a59c': `Muuta alhaalta kokoa`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Muuta oikean yläkulman kokoa`,
's8db84aa4bc949af2': `Dokumentoi uusi kiinteistö`,
's8f839a03997a16d7': `Näytä tuote`,
's901ae1e236ac45d3': `Peruuta poisto`,
's907f7a97c6b29425': `Huomaa, että datamallia voidaan muokata. Käytä omalla vastuullasi.`,
's95d23d03f9147581': `Zoomaus pois`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ainesosat:`,
's9a7f60fce090ecaf': `Ominaisuuksien lataaminen epäonnistui. Yritä myöhemmin uudelleen.`,
's9b87abd68fb9df45': `Eikö löydy? Luo uusi avain {value}`,
's9c0f52425fd2f07e': `Ei välttämättä täsmää`,
's9fc41f789c63b40d': `Tuotteet`,
'sa1fa766e0d5634d7': `Ei pisteitä saatavilla`,
'sa548778b24054030': `Tutustu kaikkiin Folksonomy Engine -projektin tuottamiin ominaisuuksiin. Nämä ominaisuudet tarjoavat lisätietoja ja näkemyksiä Open Food Facts -tietokannan tuotteista.`,
'sa63907958bd0ec4b': `Muuta vasemman yläkulman kokoa`,
'sa95b4224f685a36a': `Sulje modaali`,
'sab56a1d439576fd6': `Ehdotuskuvake`,
'sac47ea2901d04c15': `Muuta vasemman alakulman kokoa`,
'sb125227d436c2925': `Hae kiinteistökonseptiasi olemassa olevasta kiinteistötietokannasta:`,
'sb125568d43642e6f': `Vastaa tuotetta koskeviin kysymyksiin.`,
'sb1c538e038f9b214': str`Erittäin hyvä osuma ${0}%`,
'sb28639570ff3b852': `luettelo kaikista kiinteistöistä`,
'sb3bdd638a58d30f4': `saada mukaan sitoutuneiden kansalaisten yhteisö,`,
'sb3cbcc1bd0fff140': `Kun olet varmistanut, että ominaisuuttasi ei ole olemassa ja yhteisö on samaa mieltä siitä, että se on hyödyllinen, sinun on ensin dokumentoitava se wikiin.`,
'sb3d4f79d9d8b71e5': `Lähetä`,
'sb560fa37a7bfb6c2': `Tälle ominaisuudelle ei löytynyt tuotteita.`,
'sb7f72e4c8a2d3357': `Suodata arvot...`,
'sb8178320160f84ea': `Näytä rajaus`,
'sbad7d2734149470b': `Vahvista`,
'sbb623d6b18d966a0': `Ravintosisältö on ilmoitettu pakkauksessa:`,
'sbd6be5cde472f37c': `Kaikkiin kysymyksiin on vastattu! Kiitos avustasi!`,
'sbd9a0b2293b3cd3c': `Annoskoko`,
'sbe472dc3c2685985': `Vastaava arvo`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Muuta yläosan kokoa`,
'sc1c08d0cbcc3bd24': `Ei täsmää`,
'sc52696641af72b53': `Asenna sovellus!`,
'sc5575e3107f87874': `Kierrä kuvaa vasemmalle`,
'sc57b630a7a70c61f': `Ehdotettu korjaus`,
'sc681b137e8f604f7': `Vahvista poisto`,
'sc6daf8a31883f8b9': `Siirrä kuvaa`,
'sc895972c88d38ca5': `Folksonomia-omaisuus`,
'sca0c3305aff570b8': str`määriteltyä annosta kohden "${0}"`,
'scace072bef961918': `Rivit`,
'scb3b0671d7b7f640': `Uusi arvo`,
'scb489a1a173ac3f0': `Kyllä`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Liity Slack-keskusteluun`,
'scdb6cad0b92721bf': `Ei löytynyt ominaisuuksia.`,
'scf23a05631f93732': `Vahvista poisto`,
'scfed2f270ef6a3aa': `Valitse alue`,
'sd1022bc1ef9204f7': `Zoomattava kuva`,
'sd1077c055cf9ba6b': `Auta meitä vahvistamaan tuotteen ainesosaluettelo.`,
'sd698d21ddecba56b': `Hei! Voit auttaa meitä parantamaan tuotetietoja vastaamalla seuraaviin kysymyksiin:`,
'sd82bc2decefa621b': `pysyä riippumattomana elintarviketeollisuudesta,`,
'sdb97e5976482606e': `Tarkista, onko ominaisuus jo olemassa`,
'sdbf806fefc584115': `Sinun pitäisi löytää`,
'sdc673e73b5c13aea': `Poista`,
'sdc792b75f1edcaba': `Auta meitä korjaamaan ainesosien oikeinkirjoitus.`,
'sdca5deead576ceee': `Muuta oikean alakulman kokoa`,
'sdcc2555c5dde524f': `Haluatko varmasti poistaa tämän kohteen? Tätä toimintoa ei voi perua.`,
'se206feec7ec57b28': `100 grammaa kohti`,
'se419a9ab36987490': `Mitätöidä`,
'se5127cf0f92e7e48': `Vinkki: löydät myös`,
'se773f50d2a16d481': `Kierrä kuvaa oikealle`,
'sebb2c6c830a44574': `tekninen infrastruktuuri (verkkosivusto/mobiilisovellus) &amp; pieni vakituinen tiimi`,
'sec6377f3c4e9b28c': `Ehdotan parempaa satoa`,
'seea3800e27baa686': `Yksittäiset tuotteet`,
'sefaba4adc4ec9219': `Folksonomiaominaisuudet`,
'seffa8ca49175b5f0': `Personoidut ominaisuudet`,
'sf44a6b3b232c28ea': str`Korvaa nykyinen arvo arvolla ${0}`,
'sf4cd86a2f5ef2588': `Tuotteen viivakoodi`,
'sf57a61152168cc81': `Auta meitä korjaamaan ainesosan tunnistus`,
'sf88b90b8ba23871c': `Tuntematon osuma`,
'sf9aee319a006c9b4': `Lisää`,
'sfacbbe968fa7d773': `Kiinteistön nimi:`,
'sfc40ea3d5d5aa6f8': `Lahjoituksesi rahoittavat voittoa tavoittelemattoman yhdistyksemme päivittäiset toimet:`,
'sfe87465d50530725': `Vastaava arvo`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  